import { useState, useEffect, useCallback } from 'react';
import { ContactService } from '@/services/contactService';
import { useAuthState } from './useAuthState';

interface ContactNotification {
  unreadCount: number;
  hasUnreadContacts: boolean;
}

export const useContactNotifications = () => {
  const [notification, setNotification] = useState<ContactNotification>({
    unreadCount: 0,
    hasUnreadContacts: false,
  });
  const [loading, setLoading] = useState(true);
  const { isAuthenticated, userType } = useAuthState();

  const checkUnreadContacts = useCallback(async () => {
    // Só verificar se for admin
    if (!isAuthenticated || userType !== 'admin') {
      setNotification({
        unreadCount: 0,
        hasUnreadContacts: false,
      });
      setLoading(false);
      return;
    }

    try {
      // Buscar todas as mensagens de contato
      const contacts = await ContactService.getAllContacts();
      
      // Contar apenas as não lidas
      const unreadCount = contacts.filter(contact => !contact.is_read).length;
      const hasUnread = unreadCount > 0;
      
      setNotification({
        unreadCount,
        hasUnreadContacts: hasUnread,
      });
    } catch (error) {
      console.error('❌ Erro ao verificar contatos não lidos:', error);
      setNotification({
        unreadCount: 0,
        hasUnreadContacts: false,
      });
    } finally {
      setLoading(false);
    }
  }, [isAuthenticated, userType]);

  // Verificar contatos não lidos quando o usuário estiver autenticado e for admin
  useEffect(() => {
    checkUnreadContacts();
    
    // Verificar a cada 30 segundos
    const interval = setInterval(() => {
      checkUnreadContacts();
    }, 30000);

    return () => clearInterval(interval);
  }, [checkUnreadContacts]);

  return {
    unreadCount: notification.unreadCount,
    hasUnreadContacts: notification.hasUnreadContacts,
    loading,
    refresh: checkUnreadContacts,
  };
};

